import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { solarDesignDraftsKey } from '@/api/queries/project/useSolarDesignDrafts';
import { solarDesignerStateKey } from '@/api/queries/project/useSolarDesignerState';
import { graphql } from '@/gql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const DeleteSolarDesignDraft = graphql(`
  mutation DeleteSolarDesignDraft($projectId: ID!, $designId: ID!) {
    deleteSolarDesignDraft(projectId: $projectId, designId: $designId)
  }
`);

export const useDeleteSolarDesign = (projectId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { designId: string }) =>
      gqlClient.request(DeleteSolarDesignDraft, {
        projectId,
        designId: input.designId,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: solarDesignDraftsKey(projectId),
      });
      void queryClient.invalidateQueries({
        queryKey: solarDesignerStateKey(projectId),
      });
      void queryClient.invalidateQueries({
        queryKey: projectKeys.overview(projectId),
      });
    },
  });
};
